import React, { useRef } from 'react';

interface LetterInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  color?: string;
}

export const LetterInput: React.FC<LetterInputProps> = ({
  value,
  onChange,
  placeholder = '',
  disabled = false,
  color = '#565758',
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.toUpperCase().slice(-1);
    onChange(newValue);
    // Auto-advance to next sibling input
    if (newValue && inputRef.current?.nextElementSibling) {
      (inputRef.current.nextElementSibling as HTMLInputElement).focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !value && inputRef.current?.previousElementSibling) {
      (inputRef.current.previousElementSibling as HTMLInputElement).focus();
    }
  };

  const filled = value.length > 0;

  return (
    <input
      ref={inputRef}
      type="text"
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      disabled={disabled}
      maxLength={1}
      aria-label={placeholder ? `Letter position ${placeholder}` : 'Letter input'}
      style={{
        width: '44px',
        height: '44px',
        textAlign: 'center',
        fontSize: '20px',
        fontWeight: 700,
        border: filled ? `2px solid ${color}` : '2px solid #3a3a3c',
        borderRadius: '6px',
        backgroundColor: filled ? color : '#121213',
        color: '#fff',
        textTransform: 'uppercase',
        boxSizing: 'border-box',
        outline: 'none',
        caretColor: '#fff',
        transition: 'border-color 0.15s, background-color 0.15s',
      }}
    />
  );
};
